import { getAntiForgeryToken, Kaggle } from "@kaggle/sdk";
import { editorErrorOccurred } from "../kernels/redux/actions/editor";
import { getLanguageFromId } from "../kernels/redux/selectors/kernelDraft";
import { AdhocClient } from "./services";

/**
 * One-off custom fetch client bindings.
 *
 * Note: All routes fetched in this must be added to the `devServer.proxy`
 * node in dev webpack configs to ensure they proxy back to the right host.
 */
const client: AdhocClient = {
  viewCompetitionsList: async (
    category: string,
    page: number,
    search: string,
    sortBy: string,
    tab: string
  ) => {
    const body = { category, page, search, sortBy, tab };
    return (
      await fetch("/competitions_search.json", {
        method: "POST",
        mode: "cors",
        headers: new Headers({
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getAntiForgeryToken(),
        }),
        credentials: "same-origin",
        body: JSON.stringify(body),
      })
    ).json();
  },

  saveDraft: ({
    kernelId,
    parentKernelVersionId,
    sequence,
    dataSources,
    languageId,
    accelerator,
    isInternetEnabled,
    source,
    sourceType,
    externalSourceUrl,
  }) => {
    const request: Kaggle.Sdk.Kernels.Requests.AutoSaveRequest = {
      kernelId,
      parentKernelVersionId,
      sequence,
      settings: {
        dataSources,
        dockerImageVersionId: null,
        accelerator,
        isInternetEnabled,
        language: getLanguageFromId(languageId).name,
        sourceType,
      },
      source,
      externalSourceUrl,
    };
    return fetch(`/requests/AutoSaveRequest`, {
      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "X-XSRF-TOKEN": getAntiForgeryToken(),
      }),
      credentials: "same-origin",
      body: JSON.stringify(request),
    }).then(response => response.json());
  },

  sendKeepAlive: (url: string) => {
    const handleError = (message?: string) => {
      if (message) {
        editorErrorOccurred(message);
      }
    };

    return fetch(url)
      .then(response => response.json())
      .then(response => {
        if (!response.success) {
          const error = ([response.error] ||
            response.errors || [
              new Error("Unsuccessful keep alive response."),
            ])[0];
          handleError(error.message || error);
        }
      })
      .catch(e => {
        handleError(e.message);
      });
  },
};

export default client;
